import React from "react";
import { render } from "react-dom";
import App from "./App";
import ErrorBoundary from "./misc/ErrorBoundary";
import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faAngleDown,
  faArrowLeft,
  faArrowRight,
  faEdit,
  faEllipsisV,
  faPauseCircle,
  faPlayCircle,
  faStepForward,
  faTimes,
  faTimesCircle,
  faUserCircle,
  faSearch,
  faRedo,
  faVolumeUp,
  faCog,
  faEnvelope,
  faSignOutAlt,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faAngleDown,
  faArrowLeft,
  faArrowRight,
  faEdit,
  faEllipsisV,
  faPauseCircle,
  faPlayCircle,
  faStepForward,
  faTimes,
  faTimesCircle,
  faUserCircle,
  faSearch,
  faRedo,
  faVolumeUp,
  faCog,
  faEnvelope,
  faSignOutAlt
);

// replacement of i tags to svg in html
// import { dom } from "@fortawesome/fontawesome-svg-core";
// dom.watch();

// import { createTheme, ThemeProvider } from "@material-ui/core/styles";

// const theme = createTheme({
//   breakpoints: {
//     values: {
//       xs: 0,
//       sm: 576,
//       md: 768,
//       lg: 992,
//       xl: 1200,
//     },
//   },
// });

const AppContainer = () => {
  return (
    <ErrorBoundary log="React outermost error boundary">
      {/*      <ThemeProvider theme={theme}>
       */}
      <App />
      {/*      </ThemeProvider> */}
    </ErrorBoundary>
  );
};

export default AppContainer;

document.addEventListener("DOMContentLoaded", (_event) => {
  render(<AppContainer />, document.querySelector("#jango_player_app"));
});
